import { render, staticRenderFns } from "./EditButtonTabLayout.vue?vue&type=template&id=29f88562&scoped=true&"
import script from "./EditButtonTabLayout.vue?vue&type=script&lang=js&"
export * from "./EditButtonTabLayout.vue?vue&type=script&lang=js&"
import style0 from "./EditButtonTabLayout.vue?vue&type=style&index=0&id=29f88562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f88562",
  null
  
)

export default component.exports